module.exports = __webpack_public_path__ + "img/156-costa-rica.871fcb6b.svg";